import { render, staticRenderFns } from "./full-route-city-recucler-list.vue?vue&type=template&id=0a25e784&"
import script from "./full-route-city-recucler-list.vue?vue&type=script&lang=ts&"
export * from "./full-route-city-recucler-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports